import {
  usePaginatedResource,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getCarCareAccounts,
  createCarCareAccount,
  updateCarCareAccount,
  deleteCarCareAccount,
} from "api/carCareAccountApi"

export const CAR_CARE_ACCOUNT_QUERY_KEY = "car-care-accounts"

// -------------------- FETCH PAGINATED --------------------
export const useCarCareAccounts = (params = {}, enabled = true) => {
  return usePaginatedResource(
    CAR_CARE_ACCOUNT_QUERY_KEY,
    getCarCareAccounts,
    params,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateCarCareAccount = () => {
  return useCreateResource(createCarCareAccount, CAR_CARE_ACCOUNT_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditCarCareAccount = () => {
  return useEditResource(updateCarCareAccount, CAR_CARE_ACCOUNT_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteCarCareAccount = () => {
  return useDeleteResource(deleteCarCareAccount, CAR_CARE_ACCOUNT_QUERY_KEY)
}
